import React, { ElementType, useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { NavLink, useLocation } from 'react-router-dom'

import useMediaQuery from '@/hooks/useMediaQuery'
import { cn } from '@/lib/utils'
import { RoutePath } from '@/routes'

import { Flex, Grid } from '../common/Box'
import DropdownMenu from '../common/DropdownMenu'
import { Text } from '../common/Text'
import { IconCreate, Tabs } from '../svgr'

const TabNavs: React.FC = () => {
  const { gtXL } = useMediaQuery()
  const { t } = useTranslation()
  const { pathname } = useLocation()

  const [open, setOpen] = useState(false)

  const renderTab = useCallback(
    (
      Icon: ElementType,
      name: string,
      paths: RoutePath | Array<{ title: string; path: RoutePath }>,
      isCreate?: boolean
    ) => {
      if (typeof paths === 'string')
        return (
          <NavLink
            to={paths}
            className={cn(
              'flex flex-col items-center justify-center',
              pathname === paths && 'text-primary'
            )}
          >
            <Icon
              className={cn('size-5', isCreate && 'origin-bottom scale-[250%]')}
            />
            <Text className="text-sm text-inherit">{name}</Text>
          </NavLink>
        )
      return (
        <DropdownMenu
          open={open}
          onOpenChange={setOpen}
          trigger={{
            children: (
              <Flex
                className={cn(
                  'flex flex-col items-center justify-center',
                  paths
                    .map(({ path }) => path)
                    .includes(pathname as RoutePath) && 'text-primary'
                )}
              >
                <Icon
                  className={cn(
                    'size-5',
                    isCreate && 'origin-bottom scale-[250%]'
                  )}
                />
                <Text className="text-sm text-inherit">{name}</Text>
              </Flex>
            )
          }}
          content={{
            align: 'center',
            className:
              'border-white/10 bg-white/5 p-2 backdrop-blur-md w-auto min-w-fit'
          }}
        >
          <Grid>
            {paths.map((child) => (
              <NavLink
                key={child.path}
                to={child.path}
                className={cn(
                  'block rounded-md p-2 text-left leading-none hover:bg-primary',
                  pathname === child.path && 'bg-primary'
                )}
                onClick={() => setOpen(false)}
              >
                {child.title}
              </NavLink>
            ))}
          </Grid>
        </DropdownMenu>
      )
    },
    [open, pathname]
  )

  if (gtXL) return null
  if (
    ![
      // RoutePath.HOME,
      // RoutePath.AIRDROP,
      // RoutePath.CREATE,
      // RoutePath.STAKING,
      // RoutePath.MINING_PLATFORM,
      // RoutePath.MINING_INFLUENCE,
      // RoutePath.PROPOSAL
      RoutePath.HOME,
      RoutePath.AIRDROP,
      RoutePath.INFLUENCE,
      RoutePath.REFERRAL,
    ].includes(pathname as RoutePath)
  )
    return null
  return (
    <>
      <div className="h-16" />
      <Grid className="fixed bottom-0 left-0 right-0 z-10 h-[52px] grid-cols-3 bg-background">
        {renderTab(Tabs.Airdrop, t('nav.airdrop'), RoutePath.AIRDROP)}
        {renderTab(Tabs.Influence, t('nav.mining.influence'), RoutePath.INFLUENCE)}
        {renderTab(Tabs.Referral, t('nav.referral'), RoutePath.REFERRAL)}

        {/* {renderTab(IconCreate, 'Create', RoutePath.CREATE, true)}
        {renderTab(Tabs.Home, t('nav.home'), RoutePath.HOME)}
        {renderTab(Tabs.Airdrop, t('nav.airdrop'), RoutePath.AIRDROP)}
        {renderTab(Tabs.Earning, t('nav.earn'), [
          {
            title: t('nav.staking'),
            path: RoutePath.STAKING
          },
          {
            title: t('nav.mining'),
            path: RoutePath.MINING_PLATFORM
          },
          {
            title: t('nav.mining.influence'),
            path: RoutePath.MINING_INFLUENCE
          }
        ])}
        {renderTab(Tabs.Proposals, t('nav.proposals'), RoutePath.PROPOSAL)} */}
      </Grid>
    </>
  )
}

export default TabNavs
